import {
  createBrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import RootScreen from "../../screens/RootScreen/RootScreen";
import LoginScreen from "../../screens/LoginScreen/LoginScreen";
import { ProtectedRoute } from "./ProtectedRoute";
import ConfirmToken from "../../screens/LoginScreen/ConfirmToken";
import ErrorScreen from "../../screens/ErrorScreen/ErrorScreen";
import OnBoarding from "../../screens/LoginScreen/Onboarding/Onboarding";
import AdminWaitingScreen from "../../screens/LoginScreen/AdminWaitingScreen";
import { TENANT } from "../../config/constants";
import CustomizationsHome from "../../screens/CustomizationsScreen/CustomizationsHome";
import UsersHomeScreen from "../../screens/UsersScreen/UsersHomeScreen";
import UserSettingsScreen from "../../screens/UsersScreen/UserSettingsScreen";
import NoAccessScreen from "../../screens/ErrorScreen/NoAccessScreen";
import UserGroupScreen from "../../screens/UsersScreen/UsersGroupsScreen";
import UsersAdminsScreen from "../../screens/UsersScreen/UsersAdminsScreen";
import ExamHomeScreen from "../../screens/ExamScreen/ExamHomeScreen";
import ExamDetailScreen from "../../screens/ExamScreen/ExamDetailScreen";
import FoldersScreen from "../../screens/FoldersScreen/FoldersScreen";
import SubFoldersScreen from "../../screens/FoldersScreen/SubFoldersScreen";
import CreateFolderScreen from "../../screens/FoldersScreen/CreateFolderScreen";
import TrainingDetailScreen from "../../screens/TrainingScreen/TrainingDetailScreen";
import UserExamsScreen from "../../screens/ExamScreen/UserExamsScreen";
import AnalyticsScreen from "../../screens/AnalyticsScreen/AnalyticsScreen";
import HomeScreen from "../../screens/HomeScreen/HomeScreen";
import SuperAdminScreen from "../../screens/SuperAdminScreen/SuperAdminScreen";
import DemoScreen from "../../screens/DemoScreen/DemoScreen";
import UpgradeScreen from "../../screens/DemoScreen/UpgradeScreen";
import UserExamDetails from "../../screens/ExamScreen/UserExamDetails";
import UserExamsSearch from "../../screens/ExamScreen/UserExamsSearch";
import CommunicationsHome from "../../screens/CommunicationsScreen/CommunicationsHome";
import CommunicationDetails from "../../screens/CommunicationsScreen/CommunicationDetails";
import QuestionBankHomeScreen from "../../screens/QuestionBankScreen/QuestionBankHomeScreen";
import ExportsHomeScreen from "../../screens/ExportsScreen/ExportsHomeScreen";
// Router creations
export const router = createBrowserRouter([
  {
    // Login Routes
    path: "/login/*",
    children: [
        { index: true, element: <LoginScreen />},
        // Sub Route
        { path: "confirm_account_email", element: <ConfirmToken />},
        { path: "waiting_approval", element: <ProtectedRoute><AdminWaitingScreen /></ProtectedRoute>},
        { path: "onboarding", element: <ProtectedRoute><OnBoarding /></ProtectedRoute>},
    ],
  },
  {
    // Demo Routes
    path: "/demo/*",
    children: [
        { index: true, element: <DemoScreen />},
        { path:"upgrade", element: <ProtectedRoute><UpgradeScreen /></ProtectedRoute>}
    ],
  },
  {
    // Main Routes
    path: "/no_access",
    element: <NoAccessScreen />
  }, 
  { 
    // Main Routes
    path: "*", 
    Component: Root,
  },
],
  {
    basename: `/${process.env.REACT_APP_TENANT ? "" : `${TENANT}/admin`}`
  }  
);

function Root() {
  // 2️⃣ `BrowserRouter` component removed, but the <Routes>/<Route>
  // component below are unchanged
  return (
    <RootScreen>
        <Routes>
          <Route path="/" element={<ProtectedRoute><HomeScreen /></ProtectedRoute>} />
          <Route path="/folders" element={<ProtectedRoute permission="trainings"><FoldersScreen /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute permission="personalizations" ><CustomizationsHome /></ProtectedRoute>} />
          <Route path="/users/">
            <Route index element={<ProtectedRoute permission="users" ><UsersHomeScreen /></ProtectedRoute>} />
            <Route path="groups" element={<ProtectedRoute permission="users" ><UserGroupScreen /></ProtectedRoute>} />
            <Route path="settings" element={<ProtectedRoute permission="users" ><UserSettingsScreen /></ProtectedRoute>} />
            <Route path="admins" element={<ProtectedRoute permission="users" ><UsersAdminsScreen /></ProtectedRoute>} />
          </Route>
          <Route path="/exams/">
            <Route index element={<ProtectedRoute permission="exams" ><ExamHomeScreen /></ProtectedRoute>} />
            <Route path="create" element={<ProtectedRoute permission="exams" ><ExamDetailScreen isNew={true} /></ProtectedRoute>} />
            <Route path="details/:exam_id" element={<ProtectedRoute permission="exams" ><ExamDetailScreen /></ProtectedRoute>} />
            <Route path="user_exams/:exam_id" element={<ProtectedRoute permission="exams" ><UserExamsScreen /></ProtectedRoute>} />
            <Route path="user_exams_search" element={<ProtectedRoute permission="exams" ><UserExamsSearch /></ProtectedRoute>} />
            <Route path="detailed_user_exam/:exam_id/:user_exam_id" element={<ProtectedRoute permission="exams" ><UserExamDetails /></ProtectedRoute>} />
          </Route>
          <Route path="/question_bank" element={<ProtectedRoute permission="exams"><QuestionBankHomeScreen /></ProtectedRoute>} />
          <Route path="/exports" element={<ProtectedRoute permission="users"><ExportsHomeScreen /></ProtectedRoute>} />
          <Route path="/folder/">
            <Route path=":folder_id" element={<ProtectedRoute permission="trainings" ><SubFoldersScreen  /></ProtectedRoute>} />
            <Route path="create/:parent_folder_id" element={<ProtectedRoute permission="trainings" ><CreateFolderScreen /></ProtectedRoute>} />
          </Route>
          <Route path="/training/">
            <Route path="details/:folder_id" element={<ProtectedRoute permission="trainings" ><TrainingDetailScreen  /></ProtectedRoute>} />
            <Route path="create/:folder_id" element={<ProtectedRoute permission="trainings" ><TrainingDetailScreen isNew={true} /></ProtectedRoute>} />
          </Route>
          <Route path="/communications"  >
            <Route index element={<ProtectedRoute permission="notifications"><CommunicationsHome /></ProtectedRoute>} />
            <Route path="details/:communication_id" element={<ProtectedRoute permission="notifications" ><CommunicationDetails  /></ProtectedRoute>} />
            <Route path="create" element={<ProtectedRoute permission="notifications" ><CommunicationDetails isNew={true}  /></ProtectedRoute>} />
          </Route>
          <Route path="/analytics" element={<ProtectedRoute permission="users"><AnalyticsScreen /></ProtectedRoute>} />
          <Route path="/super_admin" element={<ProtectedRoute is_super_admin={true}>< SuperAdminScreen/></ProtectedRoute>} />
          <Route path="/no_access_internal" element={<ProtectedRoute><ErrorScreen /></ProtectedRoute>} />
          <Route path="*" element={<ErrorScreen />} />
      </Routes>
    </RootScreen>
  );
}
